<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'

    @Component
    export class SwiperMixin extends Vue {
        showSwiper = false

        onResize() {
            this.showSwiper = true
        }

        get loop() {
            return !(
                (this.$breakpoint.lgAndUp && this.items.length <= 5) ||
                (this.$breakpoint.mdOnly && this.items.length <= 4)
            )
        }
    }

    export default SwiperMixin
</script>
